const adminPanel = {
  adminPanel: {
    einAdmin: 'Admin de EIN',
    einInstallerSetup: 'Configuración del instalador de EIN',
    installerDataUpdate: 'Actualización de datos del instalador',
    uploadFile: 'Cargar archivo',
    chooseFile: 'Elegir archivo',
    installerDataUpdateDescription:
      'Cuota del mercado del instalador de Enphase, información del patrocinador ejecutivo, etc.',
    header: 'Enlaces de barra de navegación',
    platinumTier: 'Nivel platino',
    goldTier: 'Nivel oro',
    silverTier: 'Nivel plata',
    same: 'Lo mismo para todos los niveles',
    bannerDescription: 'Descripción de banner',
    bannerLink: 'Enlace de banner',
    digitalAssets: 'Activos digitales',
    name: 'Nombre',
    file: 'Archivo',
    access: 'Acceso a categoría de niveles',
    action: 'Acción',
    all: 'Todo',
    platinum: 'Platino',
    gold: 'Oro',
    silver: 'Plata',
    addDigital: 'Añadir activos digitales',
    productInformation: 'Información del producto',
    productName: 'Nombre del producto',
    learnMoreLink: 'Enlace de Más información',
    featureName: 'Nombre de característica A/B',
    featureType: 'Tipo de característica',
    betaRelease: 'Fecha de lanzamiento beta',
    addProduct: 'Añadir información del producto',
    exclusiveUpdate: 'Enlaces exclusivos de actualizaciones',
    description: 'Descripción',
    link: 'Enlace',
    addLink: 'Añadir enlace',
    one: '1.',
    two: '2.',
    installerList: 'Lista de instaladores para acceso al producto',
    usa: 'EE. UU.',
    // TODO - Start
    usa_pr: 'USA - Puerto Rico',
    france: 'France',
    // TODO - End
    australia: 'Australia',
    belgium: 'Bélgica',
    netherlands: 'Países Bajos',
    germany: 'Alemania',
    india: 'India',
    mexico: 'México',
    country: 'País',
    fileName: 'Nombre del archivo',
    software_service: 'SOFTWARE_SERVICE',
    hardware_product: 'HARDWARE_PRODUCT',
    empty_file: 'El archivo está vacío',
    invalidFileFormat: 'Formato de archivo no válido',
    invalidFileHeader: 'Encabezado de archivo no válido',
    uploadFailed: 'Error al cargar archivo',
    invalidFile: 'Archivo no válido',
    errorDetail: {
      one: '%{errorCount} de %{count} fila ha fallado.',
      other: '%{errorCount} de %{count} filas han fallado.'
    },
    viewError: 'Visualizar errores',
    errorListText: 'Lista de errores de carga de archivo',
    companyId: 'ID de la compañía',
    message: 'Mensaje',
    sampleFileName: 'Nombre de muestra'
  }
};

export default adminPanel;
